import React, { useContext, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { Alert, Row, Table, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import AssignUserItem from "./AssignUserItem";

const AssignUserList = observer(({ onAssignSelect, setActiveComponent }) => {
    const { book } = useContext(Context);
    const [viewMode, setViewMode] = useState(localStorage.getItem("assignViewModeList") || "cards");

    const handleClick = (a) => {
        book.setSelectedCurrentUserAssign(a);
        onAssignSelect(a);
        setActiveComponent("AssignFull");
    };

    const assignments = book.currentuserassigns || [];

    const handleViewModeChange = (val) => {
        setViewMode(val);
        localStorage.setItem("assignViewModeList", val);
    };

    return (
        <>
            <div className="card justify-content-start text-start start-0 mt-2 mb-1 p-2 small bg-white rounded">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                    <h6 className="text-success mb-0 ms-1">List of Your Assignments</h6>
                    <ToggleButtonGroup
                        type="radio"
                        name="assignViewModeList"
                        value={viewMode}
                        onChange={handleViewModeChange}
                        size="sm"
                    >
                        <ToggleButton id="assign-cards" variant="outline-success" value="cards">
                            📚 Cards
                        </ToggleButton>
                        <ToggleButton id="assign-table" variant="outline-success" value="table">
                            📋 Table
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>

            {assignments.length === 0 ? (
                <Alert variant="light" className="text-muted text-center mt-2">
                    Unfortunately, you haven't any assignments yet, so this section is currently empty.<br />
                    Once you take any assignment and start reading, it will appear here automatically.
                </Alert>
            ) : viewMode === "cards" ? (
                <Row className="d-flex p-0">
                    {assignments.map(a => (
                        <AssignUserItem
                            key={a.id}
                            assignment={a}
                            onClick={() => handleClick(a)}
                        />
                    ))}
                </Row>
            ) : (
                <div className="card text-start align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
                    <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                        <Table
                            striped
                            bordered
                            hover
                            size="sm"
                            className="shadow-sm rounded small mb-0"
                            style={{ minWidth: '860px' }}
                        >
                            <thead className="table-light small text-muted">
                            <tr>
                                <th className="text-center fst-italic">#</th>
                                <th className="text-start fst-italic">Title</th>
                                <th className="text-center fst-italic">Due</th>
                                <th className="text-center fst-italic">Days</th>
                                <th className="text-center fst-italic">Earned</th>
                                <th className="text-center fst-italic">Bonus</th>
                                <th className="text-center fst-italic">Spent</th>
                                <th className="text-center fst-italic">Lang</th>
                                <th className="text-center fst-italic">Words</th>

                                <th className="text-center fst-italic">Status</th>
                                <th className="text-center fst-italic">Check Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            {assignments.map((a, index) => {
                                const dueDate = new Date((a?.start_rev_date + a?.turnaround_time) * 60 * 1000);
                                const daysToRead = Math.ceil(a.turnaround_time / 60 / 24);
                                const formattedDue = dueDate.toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                }).replace(/ /g, '-');

                                const statusConfig = {
                                    READING: { text: "READING" },
                                    READING_RIDT: { text: "READING" },
                                    READING_RE: { text: "READING" },
                                    REPORTED: { text: "AWAITING" },
                                    REPORTED_RFU: { text: "AWAITING" },
                                    REPORTED_RV: { text: "AWAITING" },
                                    SUCCESS: { text: "CONFIRMED" },
                                };

                                const statusText = statusConfig[a.assignment_status]?.text || a.assignment_status || "-";
                                const checkStatusText = statusConfig[a.check_status]?.text || a.check_status || "-";

                                return (
                                    <tr
                                        key={a.id}
                                        onClick={() => handleClick(a)}
                                        style={{ cursor: "pointer" }}
                                        className="table-row-hover small"
                                    >
                                        <td className="text-center fst-italic">{index + 1}</td>
                                        <td className="text-start">
                                            {a.book?.title?.length > 30 ? `${a.book.title.slice(0, 30)}...` : a.book?.title || "-"}
                                        </td>
                                        <td className="text-center fst-italic">{formattedDue}</td>
                                        <td className="text-center fst-italic">{daysToRead}d</td>
                                        <td className="text-center fst-italic">+{a.assignment_price_reader}</td>
                                        <td className="text-center fst-italic">{a.received_bonus ? `+${a.received_bonus}` : "-"}</td>
                                        <td className="text-center fst-italic">
                                            <b className="text-danger">
                                                {[10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27].includes(a?.assTypeId) ? (
                                                    a?.assignment_price_publisher
                                                        ? ` $${a?.book_cost_compensation} (Rebatable)`
                                                        : "N/A"
                                                ) : (
                                                    (() => {
                                                        let priceLabel;
                                                        switch (a?.booksPriceId) {
                                                            case 1:
                                                                priceLabel = " Free";
                                                                break;
                                                            case 2:
                                                                priceLabel = " $0.99";
                                                                break;
                                                            case 3:
                                                                priceLabel = " $1.99";
                                                                break;
                                                            case 4:
                                                                priceLabel = " $2.99";
                                                                break;
                                                            case 5:
                                                                priceLabel = " $3.99";
                                                                break;
                                                            case 6:
                                                                priceLabel = " $4.99";
                                                                break;
                                                            case 7:
                                                                priceLabel = " $5.99";
                                                                break;
                                                            case 8:
                                                                priceLabel = " $6.99";
                                                                break;
                                                            case 9:
                                                                priceLabel = " $7.99";
                                                                break;
                                                            case 10:
                                                                priceLabel = " $8.99";
                                                                break;
                                                            case 11:
                                                                priceLabel = " $9.99";
                                                                break;
                                                            default:
                                                                priceLabel = " Unknown Type";
                                                        }

                                                        // Добавляем " Promo" при нужных условиях
                                                        if (a?.booksPriceId === 1 && [3, 4, 5, 6, 32].includes(a?.assTypeId)) {
                                                            priceLabel += " Promo";
                                                        }

                                                        return priceLabel;
                                                    })()
                                                )}




                                            </b>
                                        </td>
                                        <td className="text-center fst-italic">{a.book?.language || "-"}</td>
                                        <td className="text-center fst-italic">{a.book?.total_words || "-"}</td>
                                        <td className="text-center fst-italic">{statusText}</td>
                                        <td className="text-center fst-italic">{checkStatusText}</td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </Table>
                    </div>
                </div>

            )}
        </>
    );
});

export default AssignUserList;
